import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["showClose"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import "core-js/modules/es6.regexp.search.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.object.assign.js";

/**
 * Created by chief on 17/4/6.
 */
import Calendar from "./rc-calendar";
import React, { Component } from "react";
import ReactDOM from 'react-dom';
import classnames from 'classnames';
import Picker from "./rc-calendar/Picker"; // import zhCN from "./locale/zh_CN";
// import enUS from "./locale/en_US";

import Icon from "../../wui-icon/src";
import InputGroup from '../../wui-input-group/src';
import Input from '../../wui-input/src';
import moment from "moment"; // import "moment/locale/zh-cn";
// import "moment/locale/en-gb";

import omit from 'omit.js';
import { prefix } from "../../wui-core/src/index.js";
import { getLangInfo, updateValueLocale } from "./lang-utils";
var cn = typeof window !== 'undefined' ? location.search.indexOf("cn") === -1 : true;
var now = moment();

if (cn) {
  now.locale("zh-cn").utcOffset(8);
} else {
  now.locale("en-gb").utcOffset(0);
}

var format = "YYYY-Wo";
var style = "\n.week-calendar .".concat(prefix, "-date-calendar-tbody > tr:hover\n.").concat(prefix, "-date-calendar-date {\n  background: #ebfaff;\n}\n\n.week-calendar .").concat(prefix, "-date-calendar-tbody > tr:hover\n.").concat(prefix, "-date-calendar-selected-day .").concat(prefix, "-date-calendar-date {\n    background: #3fc7fa;\n}\n.week-calendar .week-calendar-footer {\n  position:absolute;\n  top:0;\n  left:0;\n  bottom:0;\n  width:100%;\n  border-right: 1px solid #ccc;\n}\n");

var WeekPicker = /*#__PURE__*/function (_Component) {
  _inherits(WeekPicker, _Component);

  var _super = _createSuper(WeekPicker);

  function WeekPicker(_props, context) {
    var _this;

    _classCallCheck(this, WeekPicker);

    _this = _super.call(this, _props, context);

    _defineProperty(_assertThisInitialized(_this), "initValue", function (props) {
      var value = props.value || props.defaultValue || '';
      var format = props.format;

      if (value) {
        if (typeof value == 'string') {
          if (moment(value, format).isValid && moment(value, format).isValid()) {
            value = moment(value, format);
          } else {
            console.error('value is not in the correct format');
            value = '';
          }
        } else if (value.format && value.isValid && value.isValid()) {
          value = value;
        } else {
          console.error('value is not in the correct format');
          value = '';
        }
      }

      return value;
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function (value) {
      _this.setState({
        value: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onOpenChange", function (open) {
      _this.setState({
        open: open
      });
    });

    _defineProperty(_assertThisInitialized(_this), "dateRender", function (current) {
      var selectedValue = _this.state.value;
      var monday = moment(selectedValue).isoWeekday(1); //周一

      var sunday = moment(selectedValue).isoWeekday(7); //周日

      var startYear = monday.format("YYYY");
      var endYear = sunday.format("YYYY");
      var sundayStr = sunday.format("DD");

      if (selectedValue && current.year() === selectedValue.year() && current.week() === selectedValue.week() || startYear !== endYear && (parseInt(sundayStr) <= 3 && current.week() == monday.week() && sunday.day() < monday.day() || parseInt(sundayStr) > 3 && current.week() == sunday.week() && sunday.day() < monday.day()) //  区分跨年的情况 如果周日小于等于3 就是前一年几十周
      ) {
        return /*#__PURE__*/React.createElement("div", {
          className: "".concat(prefix, "-date-calendar-selected-day")
        }, /*#__PURE__*/React.createElement("div", {
          className: "".concat(prefix, "-date-calendar-date")
        }, current.date()));
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-date-calendar-date")
      }, current.date());
    });

    _defineProperty(_assertThisInitialized(_this), "lastWeek", function () {
      var value = _this.props.value;
      value.add(-1, "weeks");

      _this.setState({
        value: value,
        open: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "nextWeek", function () {
      var value = _this.props.value;
      value.add(+1, "weeks");

      _this.setState({
        value: value,
        open: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "nowWeek", function () {
      var now = moment();

      if (_this.state.langInfo.lang.includes('en')) {
        now.locale("en-gb").utcOffset(0);
      } else {
        now.locale("zh-cn").utcOffset(8);
      }

      var value = now;

      _this.setState({
        value: value,
        open: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderFooter", function () {
      return /*#__PURE__*/React.createElement("div", {
        className: "week-calendar-footer",
        key: "footer"
      }, /*#__PURE__*/React.createElement("span", {
        className: "week-calendar-footer-button",
        onClick: _this.lastWeek.bind(_assertThisInitialized(_this)),
        style: {
          'float': 'left'
        }
      }, _this.props.locale.lastWeek), /*#__PURE__*/React.createElement("span", {
        className: "week-calendar-footer-button",
        onClick: _this.nowWeek.bind(_assertThisInitialized(_this))
      }, _this.props.locale.nowWeek), /*#__PURE__*/React.createElement("span", {
        className: "week-calendar-footer-button",
        onClick: _this.nextWeek.bind(_assertThisInitialized(_this)),
        style: {
          'float': 'right'
        }
      }, _this.props.locale.nextWeek));
    });

    _defineProperty(_assertThisInitialized(_this), "onTypeChange", function (type) {
      _this.setState({
        type: type
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleCalendarChange", function (value) {
      _this.setState({
        value: value && Object.assign(value, {
          _type: 'week'
        }) || value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseLeave", function (e) {
      _this.setState({
        showClose: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseEnter", function (e) {
      _this.setState({
        showClose: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onClear", function (e) {
      e && e.stopPropagation && e.stopPropagation();

      _this.setState({
        value: ''
      });

      _this.props.onChange && _this.props.onChange('', '');
    });

    _defineProperty(_assertThisInitialized(_this), "getShowValue", function () {
      var value = _this.state.value;
      var monday = moment(value).isoWeekday(1); //周一

      var sunday = moment(value).isoWeekday(7); //周日

      var startYear = monday.format("YYYY");
      var endYear = sunday.format("YYYY");
      var showValue;

      if (startYear !== endYear) {
        // 是跨年周
        var sundayStr = sunday.format("DD");

        if (parseInt(sundayStr) <= 3) {
          // 周一出现在周五之后，取周一的 年-周
          showValue = monday;
        } else {
          showValue = sunday;
        }
      } else {
        showValue = value;
      }

      return showValue;
    });

    var langInfo = getLangInfo(_props.locale); //获取语言包信息

    _this.state = {
      langInfo: langInfo,
      value: _this.initValue(_props),
      open: false,
      showClose: false
    };
    return _this;
  }

  _createClass(WeekPicker, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if ("value" in nextProps) {
        this.setState({
          value: this.initValue(nextProps)
        });
      }

      if ("locale" in nextProps) {
        var langInfo = getLangInfo(nextProps.locale); //获取语言包信息

        this.setState({
          langInfo: langInfo
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var state = this.state;
      var props = this.props;

      var showClose = props.showClose,
          others = _objectWithoutProperties(props, _excluded);

      var value = state.value;
      var calendar = /*#__PURE__*/React.createElement(Calendar, {
        className: "week-calendar",
        showWeekNumber: true,
        showMonthInput: false,
        renderFooter: this.renderFooter,
        dateRender: this.dateRender,
        locale: state.langInfo.langMap,
        format: format,
        dateInputPlaceholder: this.props.placeholder // defaultValue={now} //会导致moment.locale不生效
        ,
        showDateInput: true,
        onChange: this.handleCalendarChange,
        showToday: false,
        onClear: this.onClear
      });
      var classes = classnames(props.className, "".concat(prefix, "-datepicker-container"));
      var showValue = this.getShowValue();
      updateValueLocale(props.locale, showValue); //同步moment实例的locale值

      return /*#__PURE__*/React.createElement("div", _extends({
        className: classes
      }, omit(others, ['inputReadOnly', 'closeIcon', 'renderIcon', 'format', 'locale', 'placeholder', 'className', 'allowClear', 'renderExtraFooter', 'autoTriggerChange', 'showTime', 'validatorFunc', 'inputTabKeyOpen', 'destroyOnClose', 'disabledYear'])), /*#__PURE__*/React.createElement(Picker, _extends({
        animation: "slide-up"
      }, props, {
        onOpenChange: this.onOpenChange,
        open: this.state.open,
        calendar: calendar,
        value: showValue
      }), function (_ref) {
        _objectDestructuringEmpty(_ref);

        return /*#__PURE__*/React.createElement(InputGroup, {
          simple: true,
          className: "".concat(prefix, "-datepicker-input-group"),
          onMouseEnter: _this2.onMouseEnter,
          onMouseLeave: _this2.onMouseLeave
        }, /*#__PURE__*/React.createElement(Input, {
          placeholder: _this2.props.placeholder,
          disabled: props.disabled,
          readOnly: true,
          tabIndex: "-1",
          className: _this2.props.className,
          value: showValue && showValue.format(format) || ""
        }), showClose && _this2.state.value && _this2.state.showClose && !props.disabled ? /*#__PURE__*/React.createElement(Input.Button, {
          shape: "border",
          onClick: _this2.onClear
        }, props.closeIcon()) : /*#__PURE__*/React.createElement(Input.Button, {
          shape: "border"
        }, props.renderIcon()));
      }));
    }
  }]);

  return WeekPicker;
}(Component);

WeekPicker.defaultProps = {
  closeIcon: function closeIcon() {
    return /*#__PURE__*/React.createElement(Icon, {
      type: "uf-close-c"
    });
  },
  renderIcon: function renderIcon() {
    return /*#__PURE__*/React.createElement(Icon, {
      type: "uf-calendar"
    });
  },
  locale: 'zh-cn',
  showClose: true,
  inputReadOnly: false,
  format: "YYYY-Wo"
};
export default WeekPicker;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-datepicker/src/WeekPicker.js